"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { getMapLocations } from "@/lib/api";
import type { BibleLocation } from "@/lib/types";
import { Loader2 } from "lucide-react";

const BibleMap = dynamic(() => import("@/components/map/BibleMap"), {
  ssr: false,
  loading: () => (
    <div
      className="flex items-center justify-center w-full"
      style={{ height: "calc(100vh - 64px)", background: "#0a0e1a" }}
    >
      <div className="flex items-center gap-3">
        <Loader2 size={20} className="animate-spin" style={{ color: "#c8a45e" }} />
        <span style={{ color: "#e8e0d0" }} className="text-sm">
          Loading map...
        </span>
      </div>
    </div>
  ),
});

export default function MapPage() {
  const [locations, setLocations] = useState<BibleLocation[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getMapLocations()
      .then((res) => setLocations(res.locations))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (error) {
    return (
      <div
        className="flex items-center justify-center"
        style={{ height: "calc(100vh - 64px)", background: "#0a0e1a" }}
      >
        <div className="text-center">
          <p style={{ color: "#e8e0d0" }} className="text-lg mb-2">
            Failed to load map
          </p>
          <p style={{ color: "rgba(232, 224, 208, 0.5)" }} className="text-sm">
            {error}
          </p>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div
        className="flex items-center justify-center"
        style={{ height: "calc(100vh - 64px)", background: "#0a0e1a" }}
      >
        <div className="flex items-center gap-3">
          <Loader2 size={20} className="animate-spin" style={{ color: "#c8a45e" }} />
          <span style={{ color: "#e8e0d0" }} className="text-sm">
            Loading biblical locations...
          </span>
        </div>
      </div>
    );
  }

  return (
    <div style={{ height: "calc(100vh - 64px)" }}>
      <BibleMap locations={locations} />
    </div>
  );
}
